<template>
    <v-card flat class="ma-5">
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="primary"
                class="mb-2"
                :to="{ name: $route.meta.add.route, params: { requesterType:  $route.params.id } }"
            >
                <v-icon>add</v-icon> {{ $t('departments.teamMember.addItem') }}
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <data-table :setup.sync="dataTable" @delete-item="deleteUserCompany"></data-table>
    </v-card>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'detail-tab-companyuser',
    components: {
        DataTable
    },
    vm: this,
    data: function (vm) {
        return {
            loading: true,
            dataTable: {
                loading: true,
                itemName: this.$t('departments.teamMember.dataTable.itemName'),
                headers: [
                    { text: this.$t('departments.teamMember.dataTable.headers.name'), value: 'user.name', width: '70%' },
                    {
                        text: this.$t('departments.teamMember.dataTable.headers.mainAccount'),
                        value: 'mainAccount',
                        width: '15%',
                        align: 'center',
                        sortable: false
                    },
                    {
                        text: this.$t('departments.teamMember.dataTable.headers.actions'),
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: true,
                        delete: true,
                        width: '15%'
                    }
                ],
                items: [],
                totalItems: 0,
                requesterId: '',
                requesterItemId: 'objectId',
                detailTo: '',
                editTo: vm.$route.meta.editRoute,
                editParams: vm.$route.params.id,
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['registeredAt'],
                    sortDesc: [true],
                    sortFormated: [{ value: 'registeredAt', descending: true }]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            },
            clientsId: []
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    methods: {
        getSortFormated (sortArray) {
            const sortFormated = sortArray.map((sortObj) => {
                return `${(sortObj.descending) ? '-' : ''}${sortObj.value}`
            })
            return sortFormated.join()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            window.getApp.refreshUserCompany = false
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            const endpoint = API.EndPoints.getUserCompany
            const where = {
                client: {
                    __type: 'Pointer',
                    className: 'Client',
                    objectId: this.$route.params.id
                }
            }

            const params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage,
                count: true,
                order: this.getSortFormated(this.dataTable.pagination.sortFormated),
                where: JSON.stringify(where),
                include: ['user']
            }

            await new API(endpoint, params).request()
                .then(response => {
                    this.dataTable.items = response.body.results.map((result) => {
                        result.mainAccount = (result.permissions.isMainAccount) ? this.$t('common.admin') : this.$t('common.noAdmin')
                        return result
                    })
                    this.dataTable.totalItems = response.body.count
                    this.loading = false
                    this.dataTable.loading = false
                }, (e) => {
                    this.$helpers.requestError(e)
                })
        },
        async deleteUserCompany (userCompany) {
            let endpoint = API.EndPoints.deleteUserCompany
            endpoint.id = userCompany.objectId
            let msg = ''
            await new API(endpoint).request()
                .then(() => { msg = this.$t('departments.teamMember.dataTable.deleteSuccess') })
                .catch(() => { msg = this.$t('common.errorSave') })
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
